import React from 'react';
import classnames from 'classnames';

const TypeLabel = (properties) => {
  const { text, type, color = 'grey', children } = properties;
  const classes = classnames('type-label-component', {
    [`type-${type}`]: type,
    [`color-${color}`]: !type && color,
  });

  return (
    <div
      data-testid="type-label"
      className={classes}
    >
      {text || type || null}
      {children}
    </div>
  );
};

export default TypeLabel;
